/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.13.2
 */
/**
 * This module allows custom configuration for components.
 */
import { Build } from "@stencil/core";
const existingConfig = globalThis["calciteConfig"];
export const focusTrapStack = existingConfig?.focusTrapStack || [];
const runningInE2ETest = Build.isTesting && Build.isBrowser;
export const logLevel = existingConfig?.logLevel || (runningInE2ETest ? "error" : "info");
// the following placeholders are replaced by the build
const version = "__CALCITE_VERSION__";
const buildDate = "__CALCITE_BUILD_DATE__";
const revision = "__CALCITE_REVISION__";
/**
 * Stamp the version onto the global config.
 */
export function stampVersion() {
    if (existingConfig && existingConfig.version) {
        return;
    }
    console.info(`Using Calcite Components ${version} [Date: ${buildDate}, Revision: ${revision}]`);
    const target = existingConfig || globalThis["calciteConfig"] || {};
    Object.defineProperty(target, "version", {
        value: version,
        writable: false,
    });
    globalThis["calciteConfig"] = target;
}
//# sourceMappingURL=config.js.map
